import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const timelineToggle = (timeline) => {
    if(timeline.progress() < 1){
        timeline.play();
    } else {
        timeline.restart();
    }
}

const open = gsap.timeline({
    paused: true,
});

open
    .from('.collapse', {
        y: '-100%',
        autoAlpha: 0,
    })
    .from('.animated-menu-item', {
        opacity: 0,
        x: 200,
        stagger: 0.1,
    })
    .from('.collapse__wrapper__image', {
        opacity: 0,
    }, '<')
    .from('.collapse__wrapper__extra-content', {
        y: 100,
        opacity: 0,
        autoAlpha: 0,
    });


const close = gsap.timeline({
    paused: true,
});

close
    .to('.collapse__wrapper__extra-content', {
        y: 100,
        opacity: 0,
        autoAlpha: 0,
    })
    .to('.collapse__wrapper__image', {
        opacity: 0,
    }, '<')
    .to('.animated-menu-item', {
        opacity: 0,
    }, '<')
    .to('.collapse', {
        autoAlpha: 0,
        opacity: 0,
    })
;



$('.navbar-toggler').on('click', function() {
    if ($(this).hasClass('collapsed') ) {
        $('html, body').css('overflow', 'hidden');
        timelineToggle(open);
    } else {
        timelineToggle(close);
        $('html, body').css('overflow', '');
    }
})
